export default __webpack_public_path__ + "static/media/make.13248258.svg";